import { ButtonBase } from '@material-ui/core';
import React from 'react';

export const SimpleButton = ({
  onClick,
  label,
  style,
  title,
  disabled = false,
  active = false,
}: {
  onClick?: () => void;
  label: React.ReactNode;
  style?: React.CSSProperties;
  title?: string;
  // TODO Смущает и disabled и active вместе. Возможно, стоит оставить что-то одно
  disabled?: boolean;
  active?: boolean;
}) => {
  return (
    <ButtonBase
      className="design-v3-font"
      onClick={(e: React.MouseEvent) => {
        e.stopPropagation();

        if (!disabled && !active && onClick) {
          onClick();
        }
      }}
      style={{
        borderRadius: 10,
        fontSize: 16,
        fontWeight: active ? 500 : 400,
        padding: '10px 22px',
        border: active ? '1px solid rgb(242, 245, 248)' : '1px solid rgb(242, 245, 248)',
        backgroundColor: active ? 'rgb(242, 245, 248)' : undefined,
        color: disabled || active ? 'rgb(172, 178, 187)' : '#181F28',
        lineHeight: 1.125,
        cursor: disabled || active ? 'default' : 'pointer',
        ...style,
      }}
      title={title}
      // Отключаю disabled, так как иначе при клике на кнопку
      //   не срабатывает stopPropagation и событие всплывает
      // disabled={disabled}
    >
      {label}
    </ButtonBase>
  );
};
